import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1065b5d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "box_s"
};
const _hoisted_2 = {
  class: "bt_ops"
};
const _hoisted_3 = {
  class: "time_s"
};
const _hoisted_4 = {
  class: "conts"
};
const _hoisted_5 = {
  class: "boxchas"
};
import rightChat from "./components/right-chat.vue";
import { Search } from "@element-plus/icons-vue";
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const form = ref({
      search: "",
      selectedDateRange: []
    });
    const search2 = ref("");
    const selectedDateRange = ref([]);
    const searchForm = ref();
    const rules = {
      search: [{
        required: true,
        message: "请输入检索内容",
        trigger: "blur"
      }],
      selectedDateRange: [{
        required: true,
        message: "请选择时间范围",
        trigger: "change"
      }]
    };
    const onSearch = () => {
      searchForm.value.validate(valid => {
        if (valid) {
          search2.value = form.value.search;
          selectedDateRange.value = form.value.selectedDateRange;
          // 仅在这里执行数据请求逻辑
        } else {
          console.error("Validation failed");
        }
      });
    };
    const tag_list = ref([{
      id: 1,
      name: "全部"
    }, {
      id: 2,
      name: "图片及视频"
    }, {
      id: 3,
      name: "文件"
    }, {
      id: 4,
      name: "链接"
    }, {
      id: 5,
      name: "语音"
    }]);
    const activeName = ref(1);
    const handleClick = (tab, event) => {
      console.log(tab, event);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_TimePicker = _resolveComponent("TimePicker");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
        model: form.value,
        inline: "",
        rules: rules,
        ref_key: "searchForm",
        ref: searchForm
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "内容",
          class: "form_ops",
          prop: "search"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.search = $event),
            class: "seach",
            placeholder: "输入您要检索的会话内容/关键词",
            "prefix-icon": _unref(Search),
            clearable: ""
          }, null, 8, ["modelValue", "prefix-icon"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "form_ops",
          label: "时间",
          prop: "selectedDateRange"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_TimePicker, {
            modelValue: form.value.selectedDateRange,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.selectedDateRange = $event)
          }, null, 8, ["modelValue"])])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          class: "form_ops"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: onSearch
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_tabs, {
        modelValue: activeName.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => activeName.value = $event),
        class: "demo-tabs",
        onTabClick: handleClick
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tag_list.value, (item, index) => {
          return _openBlock(), _createBlock(_component_el_tab_pane, {
            key: index,
            name: item.id,
            label: item.name
          }, null, 8, ["name", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])])]), _createElementVNode("div", _hoisted_5, [_createVNode(rightChat, {
        search: search2.value,
        selectedDateRange: selectedDateRange.value,
        activeName: activeName.value
      }, null, 8, ["search", "selectedDateRange", "activeName"])])]);
    };
  }
});